import { BaseError } from './base-error';

/** Zod 검증 이슈 타입 */
export type ZodIssue = {
  code: string;
  path: (string | number)[];
  message: string;
  [key: string]: unknown;
};

/**
 * Model 파싱/검증 실패 시 발생하는 에러
 *
 * @example
 * ```ts
 * const result = partnerSchema.safeParse(data);
 * if (!result.success) {
 *   throw new ModelError('Partner 파싱 실패', result.error.issues);
 * }
 * ```
 */
export class ModelError extends BaseError {
  name = 'ModelParseError';

  /** Zod 검증 실패 상세 정보 */
  issues?: ZodIssue[];

  constructor(info: string, issues?: ZodIssue[], cause?: unknown) {
    super(info, cause);
    this.issues = issues;
  }
}
